import(/* webpackMode: "eager" */ "/repo/web-app/src/app/global-error.tsx");
